import { makeSelectedEvent } from 'app/pages/TicketSalePage/slice/selectors';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { isRenderedInsideEmbed } from 'utils/isRenderedInsideEmbed';

const CoverImage = () => {
  const { pathname } = useLocation();
  const { cover } = useSelector(makeSelectedEvent);
  const [imageSource, setImageSource] = useState(cover?.small);

  useEffect(() => {
    if (cover) {
      const img = new Image();
      img.src = cover.original;
      img.onload = () => {
        setImageSource(cover.original);
      };
    }
  }, [cover?.small]);

  if (!cover || isRenderedInsideEmbed || pathname.includes('/reserve-seats')) {
    return null;
  }

  return (
    <div
      className="h-[160px] min-[440px]:h-[200px] sm:h-[300px] bg-cover bg-center mb-3 rounded-md sm:-mx-2 border shadow-sm"
      style={{ backgroundImage: `url(${imageSource})` }}
    />
  );
};

export default CoverImage;
